import React, { useContext } from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'
import { RouteContext } from '../route-provider'

const RemoteAppConfigPage = React.lazy(
  // @ts-ignore
  () => import('platformAppConfig/AppConfigApp')
)

export const AppConfigPage = () => {
  const { organizationID } = useContext(RouteContext)

  return (
    <RemoteComponent>
      <RemoteAppConfigPage
        basename={`/${organizationID}/deployment-hub/`}
        testId="app-config-page"
      />
    </RemoteComponent>
  )
}
